import React, { FC } from 'react';

// mui
import { List } from '@mui/material';

// components
import MerchantItemsListItem from 'src/components/Items/MerchantItemsListItem';

//types
import { Item } from 'src/shared/interfaces/items.interface';

interface Props {
  items: Item[] | null[];
  onItemClick?(item: Item): void;
}

const MerchantItemsList: FC<Props> = ({ items, onItemClick = () => {} }) => {
  return (
    <List sx={{ width: '100%' }} disablePadding>
      {items.map((item, index) =>
        item ? (
          <MerchantItemsListItem key={item.id} item={item} onClick={() => onItemClick(item)} />
        ) : (
          <MerchantItemsListItem key={index - items.length} item={item} />
        )
      )}
    </List>
  );
};

export default MerchantItemsList;
